import React, { memo } from 'react'
import { StatefulTooltip } from 'baseui/tooltip'
import Classnames from 'classnames'

// recoil
import { useRecoilValue, useRecoilState } from 'recoil'
import { isBuilder, screen, screenOpen } from '@/store/builder/store'

import { opDesc } from '@/utils/store/onepager_template'

function HeroDesc({ headerLayout, getDesign }) {
  // const [description] = useAtom(opDesc)
  const description = useRecoilValue(opDesc)
  const builder = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)

  const handleCopyClick = () => {
    setScreen('copy')
    setScreenOpen(true)
  }

  return (
    <>
      {/* if builder add tool tip */}

      {builder && (
        <StatefulTooltip
          content={() => 'Edit Description'}
          showArrow
          placement="left"
        >
          <p
            onClick={handleCopyClick}
            className={Classnames(
              'heroBlurb text-center text-base md:text-xl font-medium cursor-pointer hover:opacity-75 ',
              {
                'md:text-left': headerLayout == 'default' || !headerLayout,
                'md:text-center md:px-20': headerLayout == 'center',
              }
            )}
            style={{
              fontSize: getDesign.sub_headline_text_size
                ? getDesign.sub_headline_text_size + 'px'
                : 'auto',
              lineHeight: getDesign.sub_headline_lineheight
                ? getDesign.sub_headline_lineheight + 'px'
                : 'auto',
              paddingLeft: getDesign.sub_headline_padding
                ? getDesign.sub_headline_padding + '%'
                : 'auto',
              paddingRight: getDesign.sub_headline_padding
                ? getDesign.sub_headline_padding + '%'
                : 'auto',
              marginTop: getDesign.sub_headline_margintop
                ? getDesign.sub_headline_margintop + 'px'
                : 'auto',
            }}
          >
            {description}
          </p>
        </StatefulTooltip>
      )}

      {/* not in builder */}

      {!builder && (
        <p
          className={Classnames(
            'heroBlurb text-center text-base md:text-xl font-medium',
            {
              'md:text-left': headerLayout == 'default' || !headerLayout,
              'md:text-center md:px-20': headerLayout == 'center',
            }
          )}
          style={{
            fontSize: getDesign.sub_headline_text_size
              ? getDesign.sub_headline_text_size + 'px'
              : 'auto',
            lineHeight: getDesign.sub_headline_lineheight
              ? getDesign.sub_headline_lineheight + 'px'
              : 'auto',
            paddingLeft: getDesign.sub_headline_padding
              ? getDesign.sub_headline_padding + '%'
              : 'auto',
            paddingRight: getDesign.sub_headline_padding
              ? getDesign.sub_headline_padding + '%'
              : 'auto',
            marginTop: getDesign.sub_headline_margintop
              ? getDesign.sub_headline_margintop + 'px'
              : 'auto',
          }}
        >
          {description}
        </p>
      )}
    </>
  )
}

export default memo(HeroDesc)
// export default HeroDesc
